// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,400i,600,700,800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Reset
 */
html {
  color: #222;
  font-size: 1em;
  line-height: 1.4;
}

::selection {
  background: #b3d4fc;
  text-shadow: none;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

textarea {
  resize: vertical;
}

.browserupgrade {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

.hidden {
  display: none !important;
}

.visuallyhidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
}

.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
  white-space: inherit;
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

@media only screen and (min-width: 35em) {
  /* Style adjustments for viewports that meet the condition */
}
@media print, (min-resolution: 1.25dppx), (min-resolution: 120dpi) {
  /* Style adjustments for high resolution devices */
}
@media print {
  *,
  *:before,
  *:after {
    background: transparent !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
  a,
  a:visited {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ")";
  }
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  a[href^="#"]:after,
  a[href^="javascript:"]:after {
    content: "";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
}
/**
 * Typography
 */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #383838;
}

*::-webkit-scrollbar {
  width: 8px;
  background-color: #383838;
}

*::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #6b6b6b;
}

@font-face {
  font-family: "Artifakt";
  font-style: normal;
  src: local("artifakt"), local("artifakt-regular"), url("https://fonts.autodesk.com/ArtifaktElement/WOFF2/Artifakt%20Element%20Regular.woff2") format("woff");
}
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 18px;
  line-height: 1.8rem;
  font-family: "Nunito", sans-serif;
  color: #a4acc4;
  font-weight: 400;
  background: #ecf0f3;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  body {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  body {
    font-size: 15px;
  }
}

::-webkit-input-placeholder {
  color: #a4acc4;
}

:-moz-placeholder {
  color: #a4acc4;
}

::-moz-placeholder {
  color: #a4acc4;
}

:-ms-input-placeholder {
  color: #a4acc4;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Nunito", sans-serif;
  color: #ffffff;
}

h1 {
  font-size: 3.2857rem;
  line-height: 4rem;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  h1 {
    font-size: 2.9857rem;
    line-height: 3.4rem;
  }
}
@media only screen and (max-width: 767px) {
  h1 {
    font-size: 2.6857rem;
    line-height: 3.1rem;
  }
}

h2 {
  font-size: 2.57rem;
  line-height: 3.2857rem;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  h2 {
    font-size: 2.37rem;
    line-height: 3.0857rem;
  }
}
@media only screen and (max-width: 767px) {
  h2 {
    font-size: 2.17rem;
    line-height: 2.857rem;
  }
}

h3 {
  font-size: 2rem;
  line-height: 2.7rem;
}
@media only screen and (max-width: 767px) {
  h3 {
    font-size: 1.91rem;
    line-height: 2.357rem;
  }
}

h4 {
  font-size: 1.71rem;
  line-height: 2.43rem;
}
@media only screen and (max-width: 767px) {
  h4 {
    font-size: 1.51rem;
    line-height: 2.13rem;
  }
}

h5 {
  font-size: 1.43rem;
  line-height: 2.14rem;
}
@media only screen and (max-width: 767px) {
  h5 {
    font-size: 1.23rem;
    line-height: 2.04rem;
  }
}

h6 {
  font-size: 1.14rem;
  line-height: 1.857rem;
}
@media only screen and (max-width: 767px) {
  h6 {
    font-size: 1.04rem;
    line-height: 1.657rem;
  }
}

::-ms-selection {
  background: #037fff;
  color: #ffffff;
}

::-o-selection {
  background: #037fff;
  color: #ffffff;
}

::selection {
  background: #037fff;
  color: #ffffff;
}

a:hover, a:focus, a:active {
  text-decoration: none;
  outline: none;
}

a,
button {
  cursor: pointer;
}

button,
select,
textarea {
  background: transparent;
  border: 1px solid #2e344e;
  font-family: "Nunito", sans-serif;
  color: #a4acc4;
}
button ::-webkit-input-placeholder,
select ::-webkit-input-placeholder,
textarea ::-webkit-input-placeholder {
  color: #a4acc4;
}
button :-moz-placeholder,
select :-moz-placeholder,
textarea :-moz-placeholder {
  color: #a4acc4;
}
button ::-moz-placeholder,
select ::-moz-placeholder,
textarea ::-moz-placeholder {
  color: #a4acc4;
}
button :-ms-input-placeholder,
select :-ms-input-placeholder,
textarea :-ms-input-placeholder {
  color: #a4acc4;
}
button:focus, button:active,
select:focus,
select:active,
textarea:focus,
textarea:active {
  outline: none;
  border-color: #037fff;
}

select,
textarea {
  width: 100%;
  font-size: 14px;
  vertical-align: middle;
}

select,
button {
  height: 50px;
  padding: 0 15px;
}
@media only screen and (max-width: 767px) {
  select,
  button {
    height: 44px;
  }
}

textarea {
  padding: 10px 15px;
}

blockquote {
  border-left: 5px solid #037fff;
  font-size: 18px;
  line-height: 27px;
  padding: 40px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}
blockquote::after {
  content: "\\f10d";
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: -1;
  transform: translate(-50%, -50%);
  font-size: 108px;
  color: #f6f6f6;
}
blockquote p {
  margin-bottom: 10px;
}
blockquote footer {
  font-size: 14px;
}
blockquote footer a {
  color: #037fff;
}
blockquote footer a:hover {
  color: #037fff;
}
@media only screen and (max-width: 767px) {
  blockquote {
    font-size: 16px;
    line-height: 25px;
    padding: 20px;
  }
}

[class^=flaticon-],
[class*=" flaticon-"],
[class^=flaticon-],
[class*=" flaticon-"] {
  line-height: 1;
}
[class^=flaticon-]::before, [class^=flaticon-]::after,
[class*=" flaticon-"]::before,
[class*=" flaticon-"]::after,
[class^=flaticon-]::before,
[class^=flaticon-]::after,
[class*=" flaticon-"]::before,
[class*=" flaticon-"]::after {
  margin-left: 0;
  font-size: inherit;
  vertical-align: middle;
}

.stylish-list {
  padding-left: 0;
}
.stylish-list li {
  list-style: none;
  line-height: 30px;
  position: relative;
  padding-left: 35px;
}
.stylish-list i {
  position: absolute;
  left: 0;
  top: 7px;
  font-size: 16px;
  color: #037fff;
}

/**
 * Utilities
 */
.pda-wrapper {
  margin-top: 56px;
  padding-left: 301px;
  z-index: 3;
}

.pda-with-layout-body-wrapper {
  padding: 20px;
}

.pda-float-left {
  float: left;
  font-family: artifakt;
  font-weight: bold;
}

.pda-float-right {
  padding-left: 15px;
  float: right;
}

/**
 * Button
 */
.pda-dropdown-button {
  padding: 20px;
  text-decoration: none;
  font-size: 0.94rem;
  color: #ffffff;
  display: block;
  border: none;
  transition: all 0.4s ease-out;
  width: 100%;
  text-align: left;
  cursor: pointer;
  outline: none;
}
.pda-dropdown-button.active {
  background: rgba(3, 127, 255, 0.2);
  color: #037fff;
}
.pda-dropdown-button:hover {
  color: #037fff;
}

.pda-upload-button.with-card {
  padding-top: 10px;
  font-family: artifakt;
  left: 80.3%;
  top: 10px;
  width: 100%;
}

.pda-upload-button-large {
  font-family: artifakt;
  left: 66.6%;
  top: 10px;
}

.pda-button {
  background-color: #0696d7;
  border-color: #0696d7;
  border: none;
  color: white;
  line-height: 15px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  height: 40px;
  font-size: 1.2rem;
}
.pda-button.grow {
  width: 100%;
}
.pda-button:hover {
  background-color: #006EAF;
  border-color: #006EAF;
}

.pda-button-export {
  background-color: #0696d7;
  border-color: #0696d7;
  border: none;
  color: white;
  line-height: 15px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  height: 40px;
}
.pda-button-export:hover {
  background-color: #006EAF;
  border-color: #006EAF;
}

.pda-button-radio label {
  padding-left: 10px;
  color: #414141;
  font-size: 0.9em;
  font-family: artifakt;
}

.pda-offering-upload-button-medium, .pda-locale-upload-button-medium {
  padding-top: 10px;
}

/**
 * Header Styles
 */
.pda-header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 2;
}

/**
 * Header Styles
 */
.pda-sidenav {
  position: fixed;
  padding-top: 5px;
  height: 100vh;
  width: 300px;
  background: rgb(69.520979021, 80.1258741259, 98.979020979);
  border-right: 1px solid #939ca5;
  z-index: 1;
}
.pda-sidenav h4 {
  font-family: sans-serif;
  font-weight: 550;
  font-size: 23px;
  padding-left: 20px;
  padding-top: 10px;
}
.pda-sidenav-dropdown {
  padding-left: 20px;
  line-height: 120%;
}
.pda-sidenav-dropdown li {
  display: inline-block;
}
.pda-sidenav-dropdown.hidden {
  display: none;
}
.pda-sidenav-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  overflow-y: auto;
}
.pda-sidenav-toggler {
  position: absolute;
  left: 100%;
  top: 20px;
  padding: 0;
  height: 50px;
  width: 50px;
  text-align: center;
  font-size: 1.6rem;
  background: rgb(251.6290322581, 252.3387096774, 252.8709677419);
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
}
.pda-sidenav-toggler:focus {
  border-color: #2e344e;
}
.pda-sidenav-image {
  padding: 20px 0;
  display: block;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #2e344e;
}
.pda-sidenav-image a {
  height: 200px;
  width: 200px;
  border-radius: 1000px;
  border: 7px solid #2e344e;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
}
.pda-sidenav-menu {
  width: 100%;
  margin: 15px 0;
}
.pda-sidenav-menu li {
  list-style: none;
  text-align: left;
  display: block;
}
.pda-sidenav-menu li:not(:last-child) {
  margin-bottom: 1px;
}
.pda-sidenav-menu li a {
  text-transform: capitalize;
  text-decoration: none;
  font-size: 0.94rem;
  letter-spacing: 0.85px;
  display: block;
  padding: 5px 0;
  padding-left: 20px;
  color: #ffffff;
  transition: all 0.4s ease-out;
  font-weight: 400;
  position: relative;
}
.pda-sidenav-menu li a.active {
  background: rgba(3, 127, 255, 0.2);
  color: #037fff;
}
.pda-sidenav-menu li a:hover {
  color: #037fff;
}
.pda-sidenav-copyright {
  display: block;
  width: 100%;
  text-align: center;
  margin-bottom: 0;
  font-size: 1rem;
  padding: 15px 0;
  border-top: 1px solid #2e344e;
}
.pda-sidenav-copyright a {
  color: #a4acc4;
  transition: all 0.4s ease-out;
}
.pda-sidenav-copyright a:hover {
  color: #037fff;
}
.pda-sidenav.is-visible {
  transform: translateX(0);
}

.pda-submodule {
  color: black;
  background-color: black;
}

.pda-section-disabled {
  opacity: 0.3;
  pointer-events: none;
}

.pda-page-container {
  padding-left: 10px;
  height: 600px;
}

.pda-button-radio-container {
  padding: 20px;
}

.pda-page-text-container {
  position: relative;
  padding-left: 10px;
  padding-top: 2%;
}

.pda-page-wrapped-component-container {
  position: relative;
  padding-top: 20%;
  padding-left: 50%;
}

.pda-page-title {
  position: relative;
  padding-top: 1%;
}

.pda-page-description {
  position: relative;
  padding-top: 5%;
}

.pda-home-card-1 {
  float: left;
  padding-left: 30px;
}

.pda-home-card-2 {
  position: relative;
  padding-left: 30px;
  float: left;
}

.pda-home-info {
  font-family: artifakt;
  color: #4d4d4d;
  font-weight: bold;
  padding-top: 30px;
  padding-left: 30px;
  padding-bottom: 15px;
}
.pda-home-info-support {
  font-family: artifakt;
  color: #4d4d4d;
  font-weight: bold;
}

.pda-drag-drop-card {
  background: white;
  height: 250px;
  width: 100%;
  text-align: center;
  display: inline-block;
  min-width: 400px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}
.pda-drag-drop-card-body {
  margin: 20px auto;
  width: 90%;
  padding: 3px;
  align-items: center;
  background: white;
  border: 1px dashed #dcdcdc;
  height: 11.5em;
  display: inline-block;
  border-radius: 6px;
  outline: none;
}
.pda-drag-drop-card-body h5, .pda-drag-drop-card-body h6 {
  color: #312f2f;
  font-family: artifakt;
}
.pda-drag-drop-card-body h5 {
  font-size: 1.2rem;
  padding: 20px;
}
.pda-drag-drop-card-body h6 {
  font-size: 1rem;
}
.pda-drag-drop-card-body:hover {
  cursor: pointer;
  border: 1px dashed #7993b0;
  background: rgba(128, 128, 128, 0.05);
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  transition: 0.3s;
}

.pda-drad-drop-card-input {
  color: white;
  border: 1px solid white;
}

.pda-upload-grid-wrapper {
  padding-top: 50px;
}

.pda-offering-effective-date-upload-container p {
  font-family: artifakt;
  font-size: 0.9rem;
  color: #4d4d4d;
  padding-top: 10px;
}

.pda-upload-progress-bar {
  position: relative;
  padding-top: 30px;
}

.pda-selection-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/*
 * Title
 */
.mi-sectiontitle {
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
}
.mi-sectiontitle span {
  position: absolute;
  left: 0;
  top: 100%;
  font-size: 6rem;
  line-height: 1;
  font-weight: 900;
  color: rgba(25, 29, 43, 0.44);
  display: inline-block;
  text-transform: uppercase;
  z-index: -1;
  transform: translateY(-40%);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}
.mi-sectiontitle h2 {
  font-weight: 700;
  position: relative;
  padding-bottom: 15px;
  text-transform: uppercase;
}
.mi-sectiontitle h2::before {
  content: "";
  position: absolute;
  left: 0;
  top: auto;
  bottom: 0;
  height: 5px;
  width: 100px;
  background: rgba(3, 127, 255, 0.3);
  border-radius: 100px;
}
.mi-sectiontitle h2::after {
  position: absolute;
  left: 0;
  top: auto;
  bottom: 0;
  height: 5px;
  width: 35px;
  background: #037fff;
  border-radius: 100px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .mi-sectiontitle span {
    font-size: 4.5rem;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .mi-sectiontitle span {
    font-size: 4.5rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .mi-sectiontitle {
    margin-bottom: 50px;
  }
  .mi-sectiontitle span {
    font-size: 4.2rem;
  }
}
@media only screen and (max-width: 767px) {
  .mi-sectiontitle {
    margin-bottom: 40px;
  }
  .mi-sectiontitle span {
    font-size: 3.8rem;
  }
}
@media only screen and (max-width: 575px) {
  .mi-sectiontitle span {
    font-size: 3.2rem;
  }
}

.mi-smalltitle {
  display: flex;
  align-items: center;
}
.mi-smalltitle h4 {
  font-weight: 700;
}
.mi-smalltitle-icon {
  vertical-align: middle;
  margin-right: 10px;
  font-size: 1.71rem;
  line-height: 2.43rem;
  color: #a4acc4;
}
@media only screen and (max-width: 767px) {
  .mi-smalltitle-icon {
    font-size: 1.51rem;
    line-height: 2.13rem;
  }
}

.pda-modal {
  width: 25rem;
  max-width: 90%;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}
.pda-modal-header {
  height: 60px;
  padding-left: 15px;
  padding-top: 15px;
  color: rgba(60, 60, 60, 0.9);
  background-color: rgba(0, 0, 0, 0.05);
  font-size: 23px;
  font-weight: bold;
  font-family: artifakt;
}
.pda-modal-footer {
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  padding: 1rem;
}
.pda-modal-body {
  height: 150px;
  padding-left: 5%;
}
.pda-modal-actions {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
}
.pda-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.75);
}

.pda-login-error p {
  color: #ec4a41;
  font-size: 300;
}

.pda-summary-card {
  transition: opacity 50000000ms ease-in;
  border-radius: 5px;
  width: 100%;
}
.pda-summary-card.primary {
  background-color: #C7E7F5;
}
.pda-summary-card.secondary {
  background-color: #FFCCCC;
}
.pda-summary-card-icon {
  padding: 10px;
  float: left;
}
.pda-summary-card-title {
  padding: 13px;
}
.pda-summary-card-title p {
  font-weight: bold;
  font-family: artifakt;
}
.pda-summary-card-title.primary {
  color: #2786AF;
}
.pda-summary-card-title.secondary {
  color: #F37D7D;
}
.pda-summary-card-body {
  padding-left: 40px;
  font-family: artifakt;
  font-size: 0.85em;
  padding-bottom: 25px;
}
.pda-summary-card-body.primary {
  color: #2786AF;
}
.pda-summary-card-body.secondary {
  color: #F37D7D;
}

.pda-backdrop {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.35);
  z-index: 4;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: auto;
  animation: show 0.5s ease;
}

.pda-card-header {
  background-color: #ffffff;
  padding: 10px;
  padding-left: 20px;
  color: #4d4d4d;
  font-family: artifakt;
  font-weight: bold;
  font-size: 1rem;
  border-radius: 5px;
}
.pda-card-body {
  padding-left: 20px;
  padding-bottom: 10px;
  background-color: #ffffff;
  color: #4d4d4d;
  font-family: artifakt;
  font-size: 0.85rem;
  border-radius: 5px;
}
.pda-card-medium-light {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  transition: 0.3s;
  background-color: white;
  border-radius: 5px;
  color: white;
  font-family: artifakt;
  width: 15rem;
}
.pda-modal-content {
  display: flex;
  justify-content: space-between;
  height: 152px;
  text-align: center;
}

.pda-offering-date-picker-container {
  padding-left: 20px;
}

.pda-offering-upload-container {
  padding-top: 10px;
  padding-left: 20px;
}

.pda-locale-upload-container {
  padding-top: 10px;
  float: inherit;
}

.pda-offerings-available-downloads {
  padding-top: 20px;
}
.pda-offerings-available-downloads-export-button {
  padding-left: 20px;
  padding-top: 30px;
}
.pda-offerings-available-downloads-list {
  padding-left: 40px;
}
.pda-offerings-available-downloads-list ul li {
  color: #4d4d4d;
  font-family: artifakt;
  font-size: 1rem;
}
.pda-offerings-available-downloads-list ul li a {
  color: #006EAF;
  text-decoration: none;
}

.pda-offering-date-picker-input {
  border-radius: 5px;
  border-color: white;
  background-color: white;
}

@media (min-width: 768px) {
  .modal {
    width: 50rem;
    left: calc((100% - 50rem) / 2);
  }
}
/*
 * Home Styles
 */
.mi-home-area {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: relative;
  z-index: 1;
}
.mi-home-particle {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}
.mi-home-content {
  text-align: center;
  padding: 50px 80px;
}
.mi-home-content h1 {
  font-weight: 700;
}
.mi-home-content p {
  margin-top: 15px;
  font-size: 1.25rem;
  line-height: 2rem;
}
.mi-home-content .mi-socialicons {
  margin-top: 20px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .mi-home-content {
    padding: 50px 0px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .mi-home-content {
    padding: 50px 0px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .mi-home-content {
    padding: 50px 0px;
  }
  .mi-home-content p {
    font-size: 1.15rem;
    line-height: 1.75rem;
  }
}
@media only screen and (max-width: 767px) {
  .mi-home-content {
    padding: 50px 0px;
  }
  .mi-home-content p {
    font-size: 1.08rem;
    line-height: 1.55rem;
  }
}
@media only screen and (max-width: 575px) {
  .mi-home-content h1 span {
    display: block;
  }
}

/*
 * About Styles
 */
.mi-about-image {
  position: relative;
}
.mi-about-image::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 65%;
  width: 15px;
  background: rgba(3, 127, 255, 0.6);
}
.mi-about-image::after {
  content: "";
  position: absolute;
  left: auto;
  right: 0;
  top: auto;
  bottom: 0;
  height: 65%;
  width: 15px;
  background: rgba(3, 127, 255, 0.6);
}
.mi-about-image img {
  width: 100%;
}
.mi-about-image-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100px;
  width: 100px;
  margin-left: -50px;
  margin-top: -50px;
  color: #ffffff;
  display: inline-block;
  visibility: hidden;
  opacity: 0;
  transform: scale(0);
  transition: all 0.4s ease-out 0s;
  pointer-events: none;
}
.mi-about-image-icon svg {
  height: 100%;
  width: 100%;
}
.mi-about-image:hover .mi-about-image-icon {
  visibility: visible;
  opacity: 0.5;
  transform: scale(1);
}
.mi-about-content h3 {
  font-weight: 600;
  margin-top: -8px;
}
.mi-about-content ul li {
  list-style: none;
  display: flex;
}
.mi-about-content ul li:not(:last-child) {
  margin-bottom: 3px;
}
.mi-about-content ul li b {
  min-width: 120px;
  display: inline-block;
  position: relative;
  margin-right: 7px;
}
.mi-about-content ul li b:after {
  content: ":";
  position: absolute;
  top: 0;
  left: auto;
  right: 0;
}
.mi-about-content .mi-button {
  margin-top: 15px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .mi-about-content {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .mi-about-image-icon {
    height: 70px;
    width: 70px;
    margin-left: -35px;
    margin-top: -35px;
  }
  .mi-about-content {
    margin-top: 30px;
  }
  .mi-about-content ul li b {
    min-width: 90px;
  }
}

/**
 * Contact
 */
.mi-contact-info {
  margin-top: -30px;
}
.mi-contact-infoblock {
  margin-top: 30px;
  background: rgb(251.6290322581, 252.3387096774, 252.8709677419);
  padding: 30px;
  display: flex;
}
.mi-contact-infoblock-icon {
  display: inline-block;
  height: 70px;
  width: 70px;
  flex: 0 0 70px;
  max-width: 70px;
  border: 1px solid #2e344e;
  text-align: center;
  line-height: 66px;
  margin-right: 20px;
}
.mi-contact-infoblock-icon svg {
  height: 30px;
  width: 30px;
}
.mi-contact-infoblock-content h6 {
  margin-top: -5px;
}
.mi-contact-infoblock-content p {
  margin-bottom: 0;
}
.mi-contact-infoblock-content p a {
  color: #a4acc4;
  transition: all 0.4s ease-out;
}
.mi-contact-infoblock-content p a:hover {
  color: #037fff;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .mi-contact-info {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 767px) {
  .mi-contact-info {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 575px) {
  .mi-contact-infoblock {
    padding: 20px;
    flex-wrap: wrap;
  }
  .mi-contact-infoblock-icon {
    height: 55px;
    width: 55px;
    flex: 0 0 55px;
    max-width: 55px;
    line-height: 51px;
  }
  .mi-contact-infoblock-content {
    margin-top: 20px;
    flex: 0 0 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/basic/_reset.scss","webpack://./src/App.scss","webpack://./src/scss/basic/_typography.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/_mixins.scss","webpack://./src/scss/basic/_utilities.scss","webpack://./src/scss/components/_button.scss","webpack://./src/scss/components/_header.scss","webpack://./src/scss/components/_sidenav.scss","webpack://./src/scss/components/_page.scss","webpack://./src/scss/components/_upload.scss","webpack://./src/scss/components/_title.scss","webpack://./src/scss/components/_widgets.scss","webpack://./src/scss/pages/_home.scss","webpack://./src/scss/pages/_about.scss","webpack://./src/scss/pages/_contact.scss"],"names":[],"mappings":"AAAA;;EAAA;AAIA;EACI,WAAA;EACA,cAAA;EACA,gBAAA;ACCJ;;ADMA;EACI,mBAAA;EACA,iBAAA;ACEJ;;ADAA;EACI,cAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,aAAA;EACA,UAAA;ACGJ;;ADDA;;;;;;EAMI,sBAAA;ACIJ;;ADDA;EACI,SAAA;EACA,SAAA;EACA,UAAA;ACIJ;;ADDA;EACI,gBAAA;ACIJ;;ADFA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;ACKJ;;ADFA;EACI,wBAAA;ACKJ;;ADFA;EACI,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;ACKJ;;ADFA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;ACKJ;;ADEA;;EAEI,YAAA;EACA,cAAA;ACCJ;;ADEA;EACI,WAAA;ACCJ;;ADGA;EACI,4DAAA;ACAJ;ADGA;EAII,kDAAA;ACJJ;ADOA;EAEI;;;IAGI,kCAAA;IACA,sBAAA;IAEA,2BAAA;IACA,4BAAA;ECNN;EDSE;;IAEI,0BAAA;ECPN;EDUE;IACI,4BAAA;ECRN;EDWE;IACI,6BAAA;ECTN;EDYE;;IAEI,WAAA;ECVN;EDaE;IACI,gCAAA;ECXN;EDcE;;IAEI,sBAAA;IACA,wBAAA;ECZN;EDeE;IACI,2BAAA;ECbN;EDgBE;;IAEI,wBAAA;ECdN;EDiBE;;;IAGI,UAAA;IACA,SAAA;ECfN;EDkBE;;IAEI,uBAAA;EChBN;AACF;ACnJA;;EAAA;AAMA;;;EAGI,SAAA;EACA,UAAA;EACA,sBAAA;ADkJJ;;AC/IA;EACI,mBAAA;EACA,yBAAA;ADkJJ;;AC/IA;EACI,UAAA;EACA,yBAAA;ADkJJ;;AC/IA;EACI,mBAAA;EACA,yBAAA;ADkJJ;;AC/IA;EACE,uBAAA;EACA,kBAAA;EACA,4JACC;ADiJH;AC5IA;EACI,mCAAA;EACA,kCAAA;EACA,eCZM;EDaN,mBAAA;EACA,iCCxBM;EDyBN,cCzCS;ED0CT,gBAAA;EACA,mBCxCY;AFsLhB;AC5II;EAVJ;IAWQ,eAAA;ED+IN;AACF;AC7II;EAdJ;IAeQ,eAAA;EDgJN;AACF;;AG7LC;EACC,cDPW;AFuMb;;AG7LC;EACC,cDXW;AF2Mb;;AG7LC;EACC,cDfW;AF+Mb;;AG7LC;EACC,cDnBW;AFmNb;;AC3JA;;;;;;EAMI,iCC7CS;ED8CT,cC9DY;AF4NhB;;AC3JA;EACI,oBAAA;EACA,iBAAA;AD8JJ;AC5JI;EAJJ;IAKQ,oBAAA;IACA,mBAAA;ED+JN;AACF;AC7JI;EATJ;IAUQ,oBAAA;IACA,mBAAA;EDgKN;AACF;;AC7JA;EACI,kBAAA;EACA,sBAAA;ADgKJ;AC9JI;EAJJ;IAKQ,kBAAA;IACA,sBAAA;EDiKN;AACF;AC/JI;EATJ;IAUQ,kBAAA;IACA,qBAAA;EDkKN;AACF;;AC/JA;EACI,eAAA;EACA,mBAAA;ADkKJ;AChKI;EAJJ;IAKQ,kBAAA;IACA,qBAAA;EDmKN;AACF;;AChKA;EACI,kBAAA;EACA,oBAAA;ADmKJ;ACjKI;EAJJ;IAKQ,kBAAA;IACA,oBAAA;EDoKN;AACF;;ACjKA;EACI,kBAAA;EACA,oBAAA;ADoKJ;AClKI;EAJJ;IAKQ,kBAAA;IACA,oBAAA;EDqKN;AACF;;AClKA;EACI,kBAAA;EACA,qBAAA;ADqKJ;ACnKI;EAJJ;IAKQ,kBAAA;IACA,qBAAA;EDsKN;AACF;;AC7JA;EACI,mBCjJU;EDkJV,cAAA;ADqKJ;;AClKA;EACI,mBCtJU;EDuJV,cAAA;ADqKJ;;AClKA;EACI,mBC3JU;ED4JV,cAAA;ADqKJ;;AChKI;EAGI,qBAAA;EACA,aAAA;ADiKR;;AC7JA;;EAEI,eAAA;ADgKJ;;AC7JA;;;EAGI,uBAAA;EACA,yBAAA;EACA,iCCjKM;EDkKN,cClLS;AFkVb;AG5UC;;;EACC,cDPW;AFuVb;AG7UC;;;EACC,cDXW;AF4Vb;AG9UC;;;EACC,cDfW;AFiWb;AG/UC;;;EACC,cDnBW;AFsWb;ACjLI;;;;;EAEI,aAAA;EACA,qBC1LM;AFgXd;;ACjLA;;EAEI,WAAA;EACA,eAAA;EACA,sBAAA;ADoLJ;;AChLA;;EAEI,YCnKkB;EDoKlB,eAAA;ADmLJ;ACjLI;EALJ;;IAMQ,YAAA;EDqLN;AACF;;AClLA;EACI,kBAAA;ADqLJ;;AClLA;EACI,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;ADqLJ;ACnLI;EACI,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;ADqLR;AClLI;EACI,mBAAA;ADoLR;ACjLI;EACI,eAAA;ADmLR;ACjLQ;EACI,cCnPE;AFsad;ACjLY;EACI,cCtPF;AFyad;AC9KI;EAtCJ;IAuCQ,eAAA;IACA,iBAAA;IACA,aAAA;EDiLN;AACF;;AC9KA;;;;EAII,cAAA;ADiLJ;AC/KI;;;;;;;EAEI,cAAA;EACA,kBAAA;EACA,sBAAA;ADsLR;;AClLA;EACI,eAAA;ADqLJ;ACnLI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ADqLR;AClLI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,cC/RM;AFmdd;;AIpdA;;EAAA;AAIA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AJsdF;;AIndA;EACE,aAAA;AJsdF;;AIndA;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;AJsdF;;AIpdA;EACE,kBAAA;EACA,YAAA;AJudF;;AK5eA;;EAAA;AAGA;EACE,aH+BqB;EG9BrB,qBAAA;EACA,kBHyBkB;EGxBlB,cAAA;EACA,cAAA;EACA,YAAA;EACA,6BH8BW;EG7BX,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AL+eF;AK9eE;EACI,kCAAA;EACA,cHNiB;AFsfvB;AK7eE;EACI,cHViB;AFyfvB;;AKzeE;EACE,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AL4eJ;;AKveA;EACE,qBAAA;EACA,WAAA;EACA,SAAA;AL0eF;;AKveA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EAEA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,iBAAA;ALyeF;AKveE;EACE,WAAA;ALyeJ;AKteE;EACE,yBAAA;EACA,qBAAA;ALweJ;;AKneA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;ALseF;AKpeE;EACE,yBAAA;EACA,qBAAA;ALseJ;;AKjeE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;ALoeJ;;AKheA;EACE,iBAAA;ALmeF;;AMrkBA;;EAAA;AAIA;EACE,eAAA;EACA,WAAA;EACC,MAAA;EACD,UAAA;ANukBF;;AO/kBA;;EAAA;AAIA;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,0DAAA;EACA,+BAAA;EACA,UAAA;APilBJ;AO/kBI;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBLOkB;EKNlB,iBLOiB;AF0kBvB;AO9kBI;EACE,kBAAA;EACA,iBAAA;APglBN;AO/kBM;EACE,qBAAA;APilBR;AO/kBM;EACE,aAAA;APilBR;AO7kBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AP+kBR;AO5kBI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,YLTc;EKUd,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,+DAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AP8kBR;AO5kBQ;EACI,qBLtDG;AFooBf;AO1kBI;EACI,eAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;AP4kBR;AO1kBQ;EACI,aAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AP4kBZ;AOxkBI;EACI,WAAA;EACA,cAAA;AP0kBR;AOxkBQ;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;AP0kBZ;AOxkBY;EACI,kBAAA;AP0kBhB;AOvkBY;EACI,0BAAA;EACA,qBAAA;EACA,kBLlEI;EKmEJ,sBLlES;EKmET,cAAA;EACA,cLlEO;EKmEP,kBLlEO;EKmEP,cL5FS;EK6FT,6BL/DH;EKgEG,gBLvEM;EKwEN,kBAAA;APykBhB;AOvkBgB;EACE,kCAAA;EACA,cLlGK;AF2qBvB;AOtkBgB;EACE,cLtGK;AF8qBvB;AOlkBI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;APokBR;AOlkBQ;EACI,cL9HC;EK+HD,6BL1FC;AF8pBb;AOlkBY;EACI,cLpIF;AFwsBd;AO/jBI;EACI,wBAAA;APikBR;;AO7jBA;EACE,YAAA;EACA,uBAAA;APgkBF;;AO7jBA;EACE,YAAA;EACA,oBAAA;APgkBF;;AQttBA;EACE,kBAAA;EACA,aAAA;ARytBF;;AQttBA;EACE,aAAA;ARytBF;;AQttBA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;ARytBF;;AQttBA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;ARytBF;;AQttBA;EACE,kBAAA;EACA,eAAA;ARytBF;;AQttBA;EACE,kBAAA;EACA,eAAA;ARytBF;;AQttBA;EACE,WAAA;EACA,kBAAA;ARytBF;;AQvtBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AR0tBF;;AQvtBA;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AR0tBF;AQxtBE;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;AR0tBJ;;AS9wBA;EACE,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,0CAAA;ATixBF;AS9wBE;EACE,iBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;ATgxBJ;AS9wBI;EACE,cAAA;EACA,qBAAA;ATgxBN;AS7wBI;EACE,iBAAA;EACA,aAAA;AT+wBN;AS5wBI;EACI,eAAA;AT8wBR;AS3wBI;EACE,eAAA;EACA,0BAAA;EACA,qCAAA;EACA,0CAAA;EACA,gBAAA;AT6wBN;;ASxwBA;EACE,YAAA;EACA,uBAAA;AT2wBF;;ASxwBA;EACE,iBAAA;AT2wBF;;ASvwBE;EACE,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AT0wBJ;;ASpwBA;EACE,kBAAA;EACA,iBAAA;ATuwBF;;ASpwBA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;ATuwBF;;AUl1BA;;EAAA;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;AVm1BF;AUj1BE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;AVm1BJ;AUh1BE;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AVk1BJ;AUh1BI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,oBAAA;AVk1BN;AU/0BI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mBRlDQ;EQmDR,oBAAA;AVi1BN;AU70BE;EACE;IACE,iBAAA;EV+0BJ;AACF;AU50BE;EACE;IACE,iBAAA;EV80BJ;AACF;AU30BE;EA/DF;IAgEI,mBAAA;EV80BF;EU50BE;IACE,iBAAA;EV80BJ;AACF;AU30BE;EAvEF;IAwEI,mBAAA;EV80BF;EU50BE;IACE,iBAAA;EV80BJ;AACF;AU30BE;EACE;IACE,iBAAA;EV60BJ;AACF;;AUz0BA;EACE,aAAA;EACA,mBAAA;AV40BF;AU10BE;EACE,gBAAA;AV40BJ;AUz0BE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cRrGS;AFg7Bb;AUx0BE;EACE;IACE,kBAAA;IACA,oBAAA;EV00BJ;AACF;;AWz7BA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,yCAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AX47BF;AW17BE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AX47BJ;AWx7BE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;AX07BJ;AWv7BE;EACE,aAAA;EACA,gBAAA;AXy7BJ;AWt7BE;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AXw7BJ;AWr7BE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,+BAAA;AXu7BJ;;AWl7BE;EACE,cAAA;EACA,cAAA;AXq7BJ;;AWj7BA;EACE,sCAAA;EACA,kBAAA;EACA,WAAA;AXo7BF;AWl7BE;EACE,yBAAA;AXo7BJ;AWj7BE;EACE,yBAAA;AXm7BJ;AWh7BE;EACE,aAAA;EACA,WAAA;AXk7BJ;AW/6BE;EACE,aAAA;AXi7BJ;AWh7BI;EACE,iBAAA;EACA,qBAAA;AXk7BN;AWh7BI;EACE,cAAA;AXk7BN;AW/6BI;EACE,cAAA;AXi7BN;AW76BE;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;AX+6BJ;AW76BI;EACE,cAAA;AX+6BN;AW56BI;EACE,cAAA;AX86BN;;AWz6BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,qCAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AX46BF;;AWx6BE;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AX26BJ;AWz6BE;EACE,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AX26BJ;AWx6BI;EACE,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AX06BN;AWx5BA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;AX05BF;;AWv5BA;EACE,kBAAA;AX05BF;;AWv5BA;EACE,iBAAA;EACA,kBAAA;AX05BF;;AWx5BA;EACE,iBAAA;EACA,cAAA;AX25BF;;AWx5BA;EACE,iBAAA;AX25BF;AWz5BE;EACE,kBAAA;EACA,iBAAA;AX25BJ;AWx5BE;EACE,kBAAA;AX05BJ;AWx5BM;EACE,cAAA;EACA,qBAAA;EACA,eAAA;AX05BR;AWz5BQ;EACE,cAAA;EACA,qBAAA;AX25BV;;AWn5BA;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;AXs5BF;;AWn5BA;EACE;IACE,YAAA;IACA,8BAAA;EXs5BF;AACF;AYvnCA;;EAAA;AAKE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AZunCJ;AYpnCE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AZsnCJ;AYnnCE;EACE,kBAAA;EACA,kBAAA;AZqnCJ;AYnnCI;EACE,gBAAA;AZqnCN;AYlnCI;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AZonCN;AYjnCI;EACE,gBAAA;AZmnCN;AY/mCE;EACE;IACE,iBAAA;EZinCJ;AACF;AY9mCE;EACE;IACE,iBAAA;EZgnCJ;AACF;AY7mCE;EACE;IACE,iBAAA;EZ+mCJ;EY7mCI;IACE,kBAAA;IACA,oBAAA;EZ+mCN;AACF;AY3mCE;EACE;IACE,iBAAA;EZ6mCJ;EY3mCI;IACE,kBAAA;IACA,oBAAA;EZ6mCN;AACF;AYzmCE;EAGM;IACE,cAAA;EZymCR;AACF;;Aa1rCA;;EAAA;AAKE;EACE,kBAAA;Ab2rCJ;AazrCI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;Ab2rCN;AaxrCI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;Ab0rCN;AavrCI;EACE,WAAA;AbyrCN;AatrCI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;AbwrCN;AatrCM;EACE,YAAA;EACA,WAAA;AbwrCR;AaprCI;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;AbsrCN;AajrCI;EACE,gBAAA;EACA,gBAAA;AbmrCN;Aa/qCM;EACE,gBAAA;EACA,aAAA;AbirCR;Aa/qCQ;EACE,kBAAA;AbirCV;Aa9qCQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AbgrCV;Aa9qCU;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;AbgrCZ;Aa1qCI;EACE,gBAAA;Ab4qCN;AaxqCE;EACE;IACE,gBAAA;Eb0qCJ;AACF;AavqCE;EAEI;IACE,YAAA;IACA,WAAA;IACA,kBAAA;IACA,iBAAA;EbwqCN;EarqCE;IACE,gBAAA;EbuqCJ;EanqCQ;IACE,eAAA;EbqqCV;AACF;;Ac/xCA;;EAAA;AAKE;EACE,iBAAA;AdgyCJ;Ac7xCE;EACE,gBAAA;EACA,+DAAA;EACA,aAAA;EACA,aAAA;Ad+xCJ;Ac7xCI;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;Ad+xCN;Ac7xCM;EACE,YAAA;EACA,WAAA;Ad+xCR;Ac1xCM;EACE,gBAAA;Ad4xCR;AczxCM;EACE,gBAAA;Ad2xCR;AczxCQ;EACE,cZtCG;EYuCH,6BZFG;AF6xCb;AczxCU;EACE,cZ5CE;AFu0Cd;AcpxCE;EACE;IACE,gBAAA;EdsxCJ;AACF;AcnxCE;EACE;IACE,gBAAA;EdqxCJ;AACF;AclxCE;EACE;IACE,aAAA;IACA,eAAA;EdoxCJ;EclxCI;IACE,YAAA;IACA,WAAA;IACA,cAAA;IACA,eAAA;IACA,iBAAA;EdoxCN;EcjxCI;IACE,gBAAA;IACA,cAAA;EdmxCN;AACF","sourcesContent":["/**\n * Reset\n */\n\nhtml {\n    color: #222;\n    font-size: 1em;\n    line-height: 1.4;\n}\n::-moz-selection {\n    background: #b3d4fc;\n    text-shadow: none;\n}\n\n::selection {\n    background: #b3d4fc;\n    text-shadow: none;\n}\nhr {\n    display: block;\n    height: 1px;\n    border: 0;\n    border-top: 1px solid #ccc;\n    margin: 1em 0;\n    padding: 0;\n}\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo {\n    vertical-align: middle;\n}\n\nfieldset {\n    border: 0;\n    margin: 0;\n    padding: 0;\n}\n\ntextarea {\n    resize: vertical;\n}\n.browserupgrade {\n    margin: 0.2em 0;\n    background: #ccc;\n    color: #000;\n    padding: 0.2em 0;\n}\n\n.hidden {\n    display: none !important;\n}\n\n.visuallyhidden {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n    white-space: nowrap;\n}\n\n.visuallyhidden.focusable:active,\n.visuallyhidden.focusable:focus {\n    clip: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    position: static;\n    width: auto;\n    white-space: inherit;\n}\n\n.invisible {\n    // visibility: hidden;\n}\n\n.clearfix:before,\n.clearfix:after {\n    content: \" \";\n    display: table;\n}\n\n.clearfix:after {\n    clear: both;\n}\n\n\n@media only screen and (min-width: 35em) {\n    /* Style adjustments for viewports that meet the condition */\n}\n\n@media print,\n(-webkit-min-device-pixel-ratio: 1.25),\n(min-resolution: 1.25dppx),\n(min-resolution: 120dpi) {\n    /* Style adjustments for high resolution devices */\n}\n\n@media print {\n\n    *,\n    *:before,\n    *:after {\n        background: transparent !important;\n        color: #000 !important;\n        -webkit-box-shadow: none !important;\n        box-shadow: none !important;\n        text-shadow: none !important;\n    }\n\n    a,\n    a:visited {\n        text-decoration: underline;\n    }\n\n    a[href]:after {\n        content: \" (\"attr(href) \")\";\n    }\n\n    abbr[title]:after {\n        content: \" (\"attr(title) \")\";\n    }\n\n    a[href^=\"#\"]:after,\n    a[href^=\"javascript:\"]:after {\n        content: \"\";\n    }\n\n    pre {\n        white-space: pre-wrap !important;\n    }\n\n    pre,\n    blockquote {\n        border: 1px solid #999;\n        page-break-inside: avoid;\n    }\n\n    thead {\n        display: table-header-group;\n    }\n\n    tr,\n    img {\n        page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n        orphans: 3;\n        widows: 3;\n    }\n\n    h2,\n    h3 {\n        page-break-after: avoid;\n    }\n}\n","/**\n * Reset\n */\n@import url(\"https://fonts.googleapis.com/css?family=Nunito:300,400,400i,600,700,800&display=swap\");\nhtml {\n  color: #222;\n  font-size: 1em;\n  line-height: 1.4;\n}\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #ccc;\n  margin: 1em 0;\n  padding: 0;\n}\n\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo {\n  vertical-align: middle;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.browserupgrade {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\n.hidden {\n  display: none !important;\n}\n\n.visuallyhidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.visuallyhidden.focusable:active,\n.visuallyhidden.focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n  white-space: inherit;\n}\n\n.clearfix:before,\n.clearfix:after {\n  content: \" \";\n  display: table;\n}\n\n.clearfix:after {\n  clear: both;\n}\n\n@media only screen and (min-width: 35em) {\n  /* Style adjustments for viewports that meet the condition */\n}\n@media print, (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 1.25dppx), (min-resolution: 120dpi) {\n  /* Style adjustments for high resolution devices */\n}\n@media print {\n  *,\n  *:before,\n  *:after {\n    background: transparent !important;\n    color: #000 !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    text-shadow: none !important;\n  }\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n  a[href^=\"#\"]:after,\n  a[href^=\"javascript:\"]:after {\n    content: \"\";\n  }\n  pre {\n    white-space: pre-wrap !important;\n  }\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n}\n/**\n * Typography\n */\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n*::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: #383838;\n}\n\n*::-webkit-scrollbar {\n  width: 8px;\n  background-color: #383838;\n}\n\n*::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: #6b6b6b;\n}\n\n@font-face {\n  font-family: \"Artifakt\";\n  font-style: normal;\n  src: local(\"artifakt\"), local(\"artifakt-regular\"), url(\"https://fonts.autodesk.com/ArtifaktElement/WOFF2/Artifakt%20Element%20Regular.woff2\") format(\"woff\");\n}\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 18px;\n  line-height: 1.8rem;\n  font-family: \"Nunito\", sans-serif;\n  color: #a4acc4;\n  font-weight: 400;\n  background: #ecf0f3;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  body {\n    font-size: 16px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  body {\n    font-size: 15px;\n  }\n}\n\n::-webkit-input-placeholder {\n  color: #a4acc4;\n}\n\n:-moz-placeholder {\n  color: #a4acc4;\n}\n\n::-moz-placeholder {\n  color: #a4acc4;\n}\n\n:-ms-input-placeholder {\n  color: #a4acc4;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Nunito\", sans-serif;\n  color: #ffffff;\n}\n\nh1 {\n  font-size: 3.2857rem;\n  line-height: 4rem;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  h1 {\n    font-size: 2.9857rem;\n    line-height: 3.4rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  h1 {\n    font-size: 2.6857rem;\n    line-height: 3.1rem;\n  }\n}\n\nh2 {\n  font-size: 2.57rem;\n  line-height: 3.2857rem;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  h2 {\n    font-size: 2.37rem;\n    line-height: 3.0857rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  h2 {\n    font-size: 2.17rem;\n    line-height: 2.857rem;\n  }\n}\n\nh3 {\n  font-size: 2rem;\n  line-height: 2.7rem;\n}\n@media only screen and (max-width: 767px) {\n  h3 {\n    font-size: 1.91rem;\n    line-height: 2.357rem;\n  }\n}\n\nh4 {\n  font-size: 1.71rem;\n  line-height: 2.43rem;\n}\n@media only screen and (max-width: 767px) {\n  h4 {\n    font-size: 1.51rem;\n    line-height: 2.13rem;\n  }\n}\n\nh5 {\n  font-size: 1.43rem;\n  line-height: 2.14rem;\n}\n@media only screen and (max-width: 767px) {\n  h5 {\n    font-size: 1.23rem;\n    line-height: 2.04rem;\n  }\n}\n\nh6 {\n  font-size: 1.14rem;\n  line-height: 1.857rem;\n}\n@media only screen and (max-width: 767px) {\n  h6 {\n    font-size: 1.04rem;\n    line-height: 1.657rem;\n  }\n}\n\n::-moz-selection {\n  background: #037fff;\n  color: #ffffff;\n}\n\n::-ms-selection {\n  background: #037fff;\n  color: #ffffff;\n}\n\n::-o-selection {\n  background: #037fff;\n  color: #ffffff;\n}\n\n::selection {\n  background: #037fff;\n  color: #ffffff;\n}\n\na:hover, a:focus, a:active {\n  text-decoration: none;\n  outline: none;\n}\n\na,\nbutton {\n  cursor: pointer;\n}\n\nbutton,\nselect,\ntextarea {\n  background: transparent;\n  border: 1px solid #2e344e;\n  font-family: \"Nunito\", sans-serif;\n  color: #a4acc4;\n}\nbutton ::-webkit-input-placeholder,\nselect ::-webkit-input-placeholder,\ntextarea ::-webkit-input-placeholder {\n  color: #a4acc4;\n}\nbutton :-moz-placeholder,\nselect :-moz-placeholder,\ntextarea :-moz-placeholder {\n  color: #a4acc4;\n}\nbutton ::-moz-placeholder,\nselect ::-moz-placeholder,\ntextarea ::-moz-placeholder {\n  color: #a4acc4;\n}\nbutton :-ms-input-placeholder,\nselect :-ms-input-placeholder,\ntextarea :-ms-input-placeholder {\n  color: #a4acc4;\n}\nbutton:focus, button:active,\nselect:focus,\nselect:active,\ntextarea:focus,\ntextarea:active {\n  outline: none;\n  border-color: #037fff;\n}\n\nselect,\ntextarea {\n  width: 100%;\n  font-size: 14px;\n  vertical-align: middle;\n}\n\nselect,\nbutton {\n  height: 50px;\n  padding: 0 15px;\n}\n@media only screen and (max-width: 767px) {\n  select,\n  button {\n    height: 44px;\n  }\n}\n\ntextarea {\n  padding: 10px 15px;\n}\n\nblockquote {\n  border-left: 5px solid #037fff;\n  font-size: 18px;\n  line-height: 27px;\n  padding: 40px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n}\nblockquote::after {\n  content: \"\\f10d\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 700;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: -1;\n  transform: translate(-50%, -50%);\n  font-size: 108px;\n  color: #f6f6f6;\n}\nblockquote p {\n  margin-bottom: 10px;\n}\nblockquote footer {\n  font-size: 14px;\n}\nblockquote footer a {\n  color: #037fff;\n}\nblockquote footer a:hover {\n  color: #037fff;\n}\n@media only screen and (max-width: 767px) {\n  blockquote {\n    font-size: 16px;\n    line-height: 25px;\n    padding: 20px;\n  }\n}\n\n[class^=flaticon-],\n[class*=\" flaticon-\"],\n[class^=flaticon-],\n[class*=\" flaticon-\"] {\n  line-height: 1;\n}\n[class^=flaticon-]::before, [class^=flaticon-]::after,\n[class*=\" flaticon-\"]::before,\n[class*=\" flaticon-\"]::after,\n[class^=flaticon-]::before,\n[class^=flaticon-]::after,\n[class*=\" flaticon-\"]::before,\n[class*=\" flaticon-\"]::after {\n  margin-left: 0;\n  font-size: inherit;\n  vertical-align: middle;\n}\n\n.stylish-list {\n  padding-left: 0;\n}\n.stylish-list li {\n  list-style: none;\n  line-height: 30px;\n  position: relative;\n  padding-left: 35px;\n}\n.stylish-list i {\n  position: absolute;\n  left: 0;\n  top: 7px;\n  font-size: 16px;\n  color: #037fff;\n}\n\n/**\n * Utilities\n */\n.pda-wrapper {\n  margin-top: 56px;\n  padding-left: 301px;\n  z-index: 3;\n}\n\n.pda-with-layout-body-wrapper {\n  padding: 20px;\n}\n\n.pda-float-left {\n  float: left;\n  font-family: artifakt;\n  font-weight: bold;\n}\n\n.pda-float-right {\n  padding-left: 15px;\n  float: right;\n}\n\n/**\n * Button\n */\n.pda-dropdown-button {\n  padding: 20px;\n  text-decoration: none;\n  font-size: 0.94rem;\n  color: #ffffff;\n  display: block;\n  border: none;\n  transition: all 0.4s ease-out;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n}\n.pda-dropdown-button.active {\n  background: rgba(3, 127, 255, 0.2);\n  color: #037fff;\n}\n.pda-dropdown-button:hover {\n  color: #037fff;\n}\n\n.pda-upload-button.with-card {\n  padding-top: 10px;\n  font-family: artifakt;\n  left: 80.3%;\n  top: 10px;\n  width: 100%;\n}\n\n.pda-upload-button-large {\n  font-family: artifakt;\n  left: 66.6%;\n  top: 10px;\n}\n\n.pda-button {\n  background-color: #0696d7;\n  border-color: #0696d7;\n  border: none;\n  color: white;\n  line-height: 15px;\n  text-align: center;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: all 0.2s ease-in-out;\n  height: 40px;\n  font-size: 1.2rem;\n}\n.pda-button.grow {\n  width: 100%;\n}\n.pda-button:hover {\n  background-color: #006EAF;\n  border-color: #006EAF;\n}\n\n.pda-button-export {\n  background-color: #0696d7;\n  border-color: #0696d7;\n  border: none;\n  color: white;\n  line-height: 15px;\n  text-align: center;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: all 0.2s ease-in-out;\n  height: 40px;\n}\n.pda-button-export:hover {\n  background-color: #006EAF;\n  border-color: #006EAF;\n}\n\n.pda-button-radio label {\n  padding-left: 10px;\n  color: #414141;\n  font-size: 0.9em;\n  font-family: artifakt;\n}\n\n.pda-offering-upload-button-medium, .pda-locale-upload-button-medium {\n  padding-top: 10px;\n}\n\n/**\n * Header Styles\n */\n.pda-header {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 2;\n}\n\n/**\n * Header Styles\n */\n.pda-sidenav {\n  position: fixed;\n  padding-top: 5px;\n  height: 100vh;\n  width: 300px;\n  background: rgb(69.520979021, 80.1258741259, 98.979020979);\n  border-right: 1px solid #939ca5;\n  z-index: 1;\n}\n.pda-sidenav h4 {\n  font-family: sans-serif;\n  font-weight: 550;\n  font-size: 23px;\n  padding-left: 20px;\n  padding-top: 10px;\n}\n.pda-sidenav-dropdown {\n  padding-left: 20px;\n  line-height: 120%;\n}\n.pda-sidenav-dropdown li {\n  display: inline-block;\n}\n.pda-sidenav-dropdown.hidden {\n  display: none;\n}\n.pda-sidenav-inner {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n  overflow-y: auto;\n}\n.pda-sidenav-toggler {\n  position: absolute;\n  left: 100%;\n  top: 20px;\n  padding: 0;\n  height: 50px;\n  width: 50px;\n  text-align: center;\n  font-size: 1.6rem;\n  background: rgb(251.6290322581, 252.3387096774, 252.8709677419);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  display: none;\n}\n.pda-sidenav-toggler:focus {\n  border-color: #2e344e;\n}\n.pda-sidenav-image {\n  padding: 20px 0;\n  display: block;\n  width: 100%;\n  text-align: center;\n  border-bottom: 1px solid #2e344e;\n}\n.pda-sidenav-image a {\n  height: 200px;\n  width: 200px;\n  border-radius: 1000px;\n  border: 7px solid #2e344e;\n  overflow: hidden;\n  display: inline-block;\n  vertical-align: middle;\n}\n.pda-sidenav-menu {\n  width: 100%;\n  margin: 15px 0;\n}\n.pda-sidenav-menu li {\n  list-style: none;\n  text-align: left;\n  display: block;\n}\n.pda-sidenav-menu li:not(:last-child) {\n  margin-bottom: 1px;\n}\n.pda-sidenav-menu li a {\n  text-transform: capitalize;\n  text-decoration: none;\n  font-size: 0.94rem;\n  letter-spacing: 0.85px;\n  display: block;\n  padding: 5px 0;\n  padding-left: 20px;\n  color: #ffffff;\n  transition: all 0.4s ease-out;\n  font-weight: 400;\n  position: relative;\n}\n.pda-sidenav-menu li a.active {\n  background: rgba(3, 127, 255, 0.2);\n  color: #037fff;\n}\n.pda-sidenav-menu li a:hover {\n  color: #037fff;\n}\n.pda-sidenav-copyright {\n  display: block;\n  width: 100%;\n  text-align: center;\n  margin-bottom: 0;\n  font-size: 1rem;\n  padding: 15px 0;\n  border-top: 1px solid #2e344e;\n}\n.pda-sidenav-copyright a {\n  color: #a4acc4;\n  transition: all 0.4s ease-out;\n}\n.pda-sidenav-copyright a:hover {\n  color: #037fff;\n}\n.pda-sidenav.is-visible {\n  transform: translateX(0);\n}\n\n.pda-submodule {\n  color: black;\n  background-color: black;\n}\n\n.pda-section-disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.pda-page-container {\n  padding-left: 10px;\n  height: 600px;\n}\n\n.pda-button-radio-container {\n  padding: 20px;\n}\n\n.pda-page-text-container {\n  position: relative;\n  padding-left: 10px;\n  padding-top: 2%;\n}\n\n.pda-page-wrapped-component-container {\n  position: relative;\n  padding-top: 20%;\n  padding-left: 50%;\n}\n\n.pda-page-title {\n  position: relative;\n  padding-top: 1%;\n}\n\n.pda-page-description {\n  position: relative;\n  padding-top: 5%;\n}\n\n.pda-home-card-1 {\n  float: left;\n  padding-left: 30px;\n}\n\n.pda-home-card-2 {\n  position: relative;\n  padding-left: 30px;\n  float: left;\n}\n\n.pda-home-info {\n  font-family: artifakt;\n  color: #4d4d4d;\n  font-weight: bold;\n  padding-top: 30px;\n  padding-left: 30px;\n  padding-bottom: 15px;\n}\n.pda-home-info-support {\n  font-family: artifakt;\n  color: #4d4d4d;\n  font-weight: bold;\n}\n\n.pda-drag-drop-card {\n  background: white;\n  height: 250px;\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  min-width: 400px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n}\n.pda-drag-drop-card-body {\n  margin: 20px auto;\n  width: 90%;\n  padding: 3px;\n  align-items: center;\n  background: white;\n  border: 1px dashed #dcdcdc;\n  height: 11.5em;\n  display: inline-block;\n  border-radius: 6px;\n  outline: none;\n}\n.pda-drag-drop-card-body h5, .pda-drag-drop-card-body h6 {\n  color: #312f2f;\n  font-family: artifakt;\n}\n.pda-drag-drop-card-body h5 {\n  font-size: 1.2rem;\n  padding: 20px;\n}\n.pda-drag-drop-card-body h6 {\n  font-size: 1rem;\n}\n.pda-drag-drop-card-body:hover {\n  cursor: pointer;\n  border: 1px dashed #7993b0;\n  background: rgba(128, 128, 128, 0.05);\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);\n  transition: 0.3s;\n}\n\n.pda-drad-drop-card-input {\n  color: white;\n  border: 1px solid white;\n}\n\n.pda-upload-grid-wrapper {\n  padding-top: 50px;\n}\n\n.pda-offering-effective-date-upload-container p {\n  font-family: artifakt;\n  font-size: 0.9rem;\n  color: #4d4d4d;\n  padding-top: 10px;\n}\n\n.pda-upload-progress-bar {\n  position: relative;\n  padding-top: 30px;\n}\n\n.pda-selection-container {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/*\n * Title\n */\n.mi-sectiontitle {\n  margin-bottom: 60px;\n  position: relative;\n  z-index: 1;\n}\n.mi-sectiontitle span {\n  position: absolute;\n  left: 0;\n  top: 100%;\n  font-size: 6rem;\n  line-height: 1;\n  font-weight: 900;\n  color: rgba(25, 29, 43, 0.44);\n  display: inline-block;\n  text-transform: uppercase;\n  z-index: -1;\n  transform: translateY(-40%);\n  user-select: none;\n  white-space: nowrap;\n}\n.mi-sectiontitle h2 {\n  font-weight: 700;\n  position: relative;\n  padding-bottom: 15px;\n  text-transform: uppercase;\n}\n.mi-sectiontitle h2::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: auto;\n  bottom: 0;\n  height: 5px;\n  width: 100px;\n  background: rgba(3, 127, 255, 0.3);\n  border-radius: 100px;\n}\n.mi-sectiontitle h2::after {\n  position: absolute;\n  left: 0;\n  top: auto;\n  bottom: 0;\n  height: 5px;\n  width: 35px;\n  background: #037fff;\n  border-radius: 100px;\n}\n@media only screen and (min-width: 1200px) and (max-width: 1599px) {\n  .mi-sectiontitle span {\n    font-size: 4.5rem;\n  }\n}\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .mi-sectiontitle span {\n    font-size: 4.5rem;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .mi-sectiontitle {\n    margin-bottom: 50px;\n  }\n  .mi-sectiontitle span {\n    font-size: 4.2rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .mi-sectiontitle {\n    margin-bottom: 40px;\n  }\n  .mi-sectiontitle span {\n    font-size: 3.8rem;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .mi-sectiontitle span {\n    font-size: 3.2rem;\n  }\n}\n\n.mi-smalltitle {\n  display: flex;\n  align-items: center;\n}\n.mi-smalltitle h4 {\n  font-weight: 700;\n}\n.mi-smalltitle-icon {\n  vertical-align: middle;\n  margin-right: 10px;\n  font-size: 1.71rem;\n  line-height: 2.43rem;\n  color: #a4acc4;\n}\n@media only screen and (max-width: 767px) {\n  .mi-smalltitle-icon {\n    font-size: 1.51rem;\n    line-height: 2.13rem;\n  }\n}\n\n.pda-modal {\n  width: 25rem;\n  max-width: 90%;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n  position: fixed;\n  left: 50%;\n  top: 30%;\n  transform: translate(-50%, -50%);\n}\n.pda-modal-header {\n  height: 60px;\n  padding-left: 15px;\n  padding-top: 15px;\n  color: rgba(60, 60, 60, 0.9);\n  background-color: rgba(0, 0, 0, 0.05);\n  font-size: 23px;\n  font-weight: bold;\n  font-family: artifakt;\n}\n.pda-modal-footer {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  padding: 1rem;\n}\n.pda-modal-body {\n  height: 150px;\n  padding-left: 5%;\n}\n.pda-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem;\n}\n.pda-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.75);\n}\n\n.pda-login-error p {\n  color: #ec4a41;\n  font-size: 300;\n}\n\n.pda-summary-card {\n  transition: opacity 50000000ms ease-in;\n  border-radius: 5px;\n  width: 100%;\n}\n.pda-summary-card.primary {\n  background-color: #C7E7F5;\n}\n.pda-summary-card.secondary {\n  background-color: #FFCCCC;\n}\n.pda-summary-card-icon {\n  padding: 10px;\n  float: left;\n}\n.pda-summary-card-title {\n  padding: 13px;\n}\n.pda-summary-card-title p {\n  font-weight: bold;\n  font-family: artifakt;\n}\n.pda-summary-card-title.primary {\n  color: #2786AF;\n}\n.pda-summary-card-title.secondary {\n  color: #F37D7D;\n}\n.pda-summary-card-body {\n  padding-left: 40px;\n  font-family: artifakt;\n  font-size: 0.85em;\n  padding-bottom: 25px;\n}\n.pda-summary-card-body.primary {\n  color: #2786AF;\n}\n.pda-summary-card-body.secondary {\n  color: #F37D7D;\n}\n\n.pda-backdrop {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  padding: 1rem;\n  background-color: rgba(0, 0, 0, 0.35);\n  z-index: 4;\n  opacity: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  animation: show 0.5s ease;\n}\n\n.pda-card-header {\n  background-color: #ffffff;\n  padding: 10px;\n  padding-left: 20px;\n  color: #4d4d4d;\n  font-family: artifakt;\n  font-weight: bold;\n  font-size: 1rem;\n  border-radius: 5px;\n}\n.pda-card-body {\n  padding-left: 20px;\n  padding-bottom: 10px;\n  background-color: #ffffff;\n  color: #4d4d4d;\n  font-family: artifakt;\n  font-size: 0.85rem;\n  border-radius: 5px;\n}\n.pda-card-medium-light {\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n  transition: 0.3s;\n  background-color: white;\n  border-radius: 5px;\n  color: white;\n  font-family: artifakt;\n  width: 15rem;\n}\n.pda-modal-content {\n  display: flex;\n  justify-content: space-between;\n  height: 152px;\n  text-align: center;\n}\n\n.pda-offering-date-picker-container {\n  padding-left: 20px;\n}\n\n.pda-offering-upload-container {\n  padding-top: 10px;\n  padding-left: 20px;\n}\n\n.pda-locale-upload-container {\n  padding-top: 10px;\n  float: inherit;\n}\n\n.pda-offerings-available-downloads {\n  padding-top: 20px;\n}\n.pda-offerings-available-downloads-export-button {\n  padding-left: 20px;\n  padding-top: 30px;\n}\n.pda-offerings-available-downloads-list {\n  padding-left: 40px;\n}\n.pda-offerings-available-downloads-list ul li {\n  color: #4d4d4d;\n  font-family: artifakt;\n  font-size: 1rem;\n}\n.pda-offerings-available-downloads-list ul li a {\n  color: #006EAF;\n  text-decoration: none;\n}\n\n.pda-offering-date-picker-input {\n  border-radius: 5px;\n  border-color: white;\n  background-color: white;\n}\n\n@media (min-width: 768px) {\n  .modal {\n    width: 50rem;\n    left: calc((100% - 50rem) / 2);\n  }\n}\n/*\n * Home Styles\n */\n.mi-home-area {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  position: relative;\n  z-index: 1;\n}\n.mi-home-particle {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: -1;\n}\n.mi-home-content {\n  text-align: center;\n  padding: 50px 80px;\n}\n.mi-home-content h1 {\n  font-weight: 700;\n}\n.mi-home-content p {\n  margin-top: 15px;\n  font-size: 1.25rem;\n  line-height: 2rem;\n}\n.mi-home-content .mi-socialicons {\n  margin-top: 20px;\n}\n@media only screen and (min-width: 1200px) and (max-width: 1599px) {\n  .mi-home-content {\n    padding: 50px 0px;\n  }\n}\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .mi-home-content {\n    padding: 50px 0px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .mi-home-content {\n    padding: 50px 0px;\n  }\n  .mi-home-content p {\n    font-size: 1.15rem;\n    line-height: 1.75rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .mi-home-content {\n    padding: 50px 0px;\n  }\n  .mi-home-content p {\n    font-size: 1.08rem;\n    line-height: 1.55rem;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .mi-home-content h1 span {\n    display: block;\n  }\n}\n\n/*\n * About Styles\n */\n.mi-about-image {\n  position: relative;\n}\n.mi-about-image::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 65%;\n  width: 15px;\n  background: rgba(3, 127, 255, 0.6);\n}\n.mi-about-image::after {\n  content: \"\";\n  position: absolute;\n  left: auto;\n  right: 0;\n  top: auto;\n  bottom: 0;\n  height: 65%;\n  width: 15px;\n  background: rgba(3, 127, 255, 0.6);\n}\n.mi-about-image img {\n  width: 100%;\n}\n.mi-about-image-icon {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  height: 100px;\n  width: 100px;\n  margin-left: -50px;\n  margin-top: -50px;\n  color: #ffffff;\n  display: inline-block;\n  visibility: hidden;\n  opacity: 0;\n  transform: scale(0);\n  transition: all 0.4s ease-out 0s;\n  pointer-events: none;\n}\n.mi-about-image-icon svg {\n  height: 100%;\n  width: 100%;\n}\n.mi-about-image:hover .mi-about-image-icon {\n  visibility: visible;\n  opacity: 0.5;\n  transform: scale(1);\n}\n.mi-about-content h3 {\n  font-weight: 600;\n  margin-top: -8px;\n}\n.mi-about-content ul li {\n  list-style: none;\n  display: flex;\n}\n.mi-about-content ul li:not(:last-child) {\n  margin-bottom: 3px;\n}\n.mi-about-content ul li b {\n  min-width: 120px;\n  display: inline-block;\n  position: relative;\n  margin-right: 7px;\n}\n.mi-about-content ul li b:after {\n  content: \":\";\n  position: absolute;\n  top: 0;\n  left: auto;\n  right: 0;\n}\n.mi-about-content .mi-button {\n  margin-top: 15px;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .mi-about-content {\n    margin-top: 30px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .mi-about-image-icon {\n    height: 70px;\n    width: 70px;\n    margin-left: -35px;\n    margin-top: -35px;\n  }\n  .mi-about-content {\n    margin-top: 30px;\n  }\n  .mi-about-content ul li b {\n    min-width: 90px;\n  }\n}\n\n/**\n * Contact\n */\n.mi-contact-info {\n  margin-top: -30px;\n}\n.mi-contact-infoblock {\n  margin-top: 30px;\n  background: rgb(251.6290322581, 252.3387096774, 252.8709677419);\n  padding: 30px;\n  display: flex;\n}\n.mi-contact-infoblock-icon {\n  display: inline-block;\n  height: 70px;\n  width: 70px;\n  flex: 0 0 70px;\n  max-width: 70px;\n  border: 1px solid #2e344e;\n  text-align: center;\n  line-height: 66px;\n  margin-right: 20px;\n}\n.mi-contact-infoblock-icon svg {\n  height: 30px;\n  width: 30px;\n}\n.mi-contact-infoblock-content h6 {\n  margin-top: -5px;\n}\n.mi-contact-infoblock-content p {\n  margin-bottom: 0;\n}\n.mi-contact-infoblock-content p a {\n  color: #a4acc4;\n  transition: all 0.4s ease-out;\n}\n.mi-contact-infoblock-content p a:hover {\n  color: #037fff;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .mi-contact-info {\n    margin-top: 50px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .mi-contact-info {\n    margin-top: 50px;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .mi-contact-infoblock {\n    padding: 20px;\n    flex-wrap: wrap;\n  }\n  .mi-contact-infoblock-icon {\n    height: 55px;\n    width: 55px;\n    flex: 0 0 55px;\n    max-width: 55px;\n    line-height: 51px;\n  }\n  .mi-contact-infoblock-content {\n    margin-top: 20px;\n    flex: 0 0 100%;\n  }\n}","/**\n * Typography\n */\n\n@import url('https://fonts.googleapis.com/css?family=Nunito:300,400,400i,600,700,800&display=swap');\n\n*,\n*::before,\n*::after {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n*::-webkit-scrollbar-track {\n    border-radius: 10px;\n    background-color: #383838;\n}\n\n*::-webkit-scrollbar {\n    width: 8px;\n    background-color: #383838;\n}\n\n*::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background-color: #6b6b6b;\n}\n\n@font-face{\n  font-family: 'Artifakt';\n  font-style: normal;\n  src:\n   local('artifakt'),\n   local('artifakt-regular'),\n   url(\"https://fonts.autodesk.com/ArtifaktElement/WOFF2/Artifakt%20Element%20Regular.woff2\") format('woff')\n}\n\nbody {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: $fz-body;\n    line-height: 1.8rem;\n    font-family: $ff-body;\n    color: $color-body;\n    font-weight: 400;\n    background: $color-bg-body;\n\n    @media #{$layout-tablet} {\n        font-size: $fz-body - 2;\n    }\n\n    @media #{$layout-mobile-lg} {\n        font-size: $fz-body - 3;\n    }\n}\n\n@include placeholder-color($color-body);\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: $ff-heading;\n    color: $color-heading;\n}\n\nh1 {\n    font-size: 3.2857rem;\n    line-height: 4rem;\n\n    @media #{$layout-tablet} {\n        font-size: 2.9857rem;\n        line-height: 3.4rem;\n    }\n\n    @media #{$layout-mobile-lg} {\n        font-size: 2.6857rem;\n        line-height: 3.1rem;\n    }\n}\n\nh2 {\n    font-size: 2.57rem;\n    line-height: 3.2857rem;\n\n    @media #{$layout-tablet} {\n        font-size: 2.37rem;\n        line-height: 3.0857rem;\n    }\n\n    @media #{$layout-mobile-lg} {\n        font-size: 2.17rem;\n        line-height: 2.857rem;\n    }\n}\n\nh3 {\n    font-size: 2rem;\n    line-height: 2.7rem;\n\n    @media #{$layout-mobile-lg} {\n        font-size: 1.91rem;\n        line-height: 2.357rem;\n    }\n}\n\nh4 {\n    font-size: 1.71rem;\n    line-height: 2.43rem;\n\n    @media #{$layout-mobile-lg} {\n        font-size: 1.51rem;\n        line-height: 2.13rem;\n    }\n}\n\nh5 {\n    font-size: 1.43rem;\n    line-height: 2.14rem;\n\n    @media #{$layout-mobile-lg} {\n        font-size: 1.23rem;\n        line-height: 2.04rem;\n    }\n}\n\nh6 {\n    font-size: 1.14rem;\n    line-height: 1.857rem;\n\n    @media #{$layout-mobile-lg} {\n        font-size: 1.04rem;\n        line-height: 1.657rem;\n    }\n}\n\n\n::-moz-selection {\n    background: $color-theme;\n    color: #ffffff;\n}\n\n::-ms-selection {\n    background: $color-theme;\n    color: #ffffff;\n}\n\n::-o-selection {\n    background: $color-theme;\n    color: #ffffff;\n}\n\n::selection {\n    background: $color-theme;\n    color: #ffffff;\n}\n\na {\n\n    &:hover,\n    &:focus,\n    &:active {\n        text-decoration: none;\n        outline: none;\n    }\n}\n\na,\nbutton {\n    cursor: pointer;\n}\n\nbutton,\nselect,\ntextarea {\n    background: transparent;\n    border: 1px solid $color-border;\n    font-family: $ff-body;\n    color: $color-body;\n    @include placeholder-color($color-body);\n\n    &:focus,\n    &:active {\n        outline: none;\n        border-color: $color-theme;\n    }\n}\n\n// input,\nselect,\ntextarea {\n    width: 100%;\n    font-size: 14px;\n    vertical-align: middle;\n}\n\n// input,\nselect,\nbutton {\n    height: $input-button-height;\n    padding: 0 15px;\n\n    @media #{$layout-mobile-lg} {\n        height: 44px;\n    }\n}\n\ntextarea {\n    padding: 10px 15px;\n}\n\nblockquote {\n    border-left: 5px solid $color-theme;\n    font-size: 18px;\n    line-height: 27px;\n    padding: 40px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    position: relative;\n    z-index: 1;\n\n    &::after {\n        content: \"\\f10d\";\n        font-family: \"Font Awesome 5 Free\";\n        font-weight: 700;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        z-index: -1;\n        transform: translate(-50%, -50%);\n        font-size: 108px;\n        color: #f6f6f6;\n    }\n\n    p {\n        margin-bottom: 10px;\n    }\n\n    footer {\n        font-size: 14px;\n\n        a {\n            color: $color-theme;\n\n            &:hover {\n                color: $color-theme;\n            }\n        }\n    }\n\n    @media #{$layout-mobile-lg} {\n        font-size: 16px;\n        line-height: 25px;\n        padding: 20px;\n    }\n}\n\n[class^=\"flaticon-\"],\n[class*=\" flaticon-\"],\n[class^=\"flaticon-\"],\n[class*=\" flaticon-\"] {\n    line-height: 1;\n\n    &::before,\n    &::after {\n        margin-left: 0;\n        font-size: inherit;\n        vertical-align: middle;\n    }\n}\n\n.stylish-list {\n    padding-left: 0;\n\n    li {\n        list-style: none;\n        line-height: 30px;\n        position: relative;\n        padding-left: 35px;\n    }\n\n    i {\n        position: absolute;\n        left: 0;\n        top: 7px;\n        font-size: 16px;\n        color: $color-theme;\n    }\n}\n","// Colors\n$color-theme: #037fff;\n$color-secondary: #ffffff;\n$color-body: #a4acc4;\n$color-heading: #ffffff;\n$color-border: #2e344e;\n$color-bg-body: #ecf0f3;\n$color-bg-dark: #0c0e16;\n$color-sidenav: #3b4454;\n$color-sidenav-border: #939ca5;\n$color-sidenav-inactive: #ffffff;\n$color-sidenav-active: #037fff;\n$color-sidenav-hover: #66c0e9;\n$color-header-body: #050506;\n$color-header-background: #f5f5f5;\n$color-header-border: #e3e3e3;\n\n\n// Font Family\n$ff-body: 'Nunito', sans-serif;\n$ff-heading: 'Nunito', sans-serif;\n\n\n// Paddings\n$padding-side-nav-left: 20px;\n$padding-side-nav-top: 10px;\n\n\n// Font Size\n$fz-body: 18px;\n\n$sidenav-font-size: 0.94rem;\n$sidenav-letter-spacing: 0.85px;\n$sidenav-font-weight: 400;\n$sidenav-font-padding: 5px 0;\n$sidenav-padding-left: 20px;\n\n\n// Input Button Height\n$input-button-height: 50px;\n$transition: all 0.4s ease-out;\n\n// Layouts\n$layout-dektop : 'only screen and (min-width: 1920px)';\n$layout-desktop-xs: 'only screen and (min-width: 1600px) and (max-width: 1919px)';\n$layout-laptop : 'only screen and (min-width: 1200px) and (max-width: 1599px)';\n$layout-notebook: 'only screen and (min-width: 992px) and (max-width: 1199px)';\n$layout-tablet : 'only screen and (min-width: 768px) and (max-width: 991px)';\n$layout-mobile-lg : 'only screen and (max-width: 767px)';\n$layout-mobile-sm : 'only screen and (max-width: 575px)';\n$layout-mobile-xs : 'only screen and (max-width: 480px)';\n\n\n\n// Social Colors\n$facebook: #3b5999;\n$messenger: #0084ff;\n$twitter: #55acee;\n$google-plus: #dd4b39;\n$pinterest: #bd081c;\n$linkedin: #0077B5;\n$flickr: #ff0084;\n$dribbble: #ea4c89;\n$google: #DD4B39;\n$skype: #1ab7ea;\n$behance: #0057ff;\n$youtube: #cd201f;\n$vimeo: #86C9EF;\n$yahoo: #410093;\n$paypal: #00588B;\n$delicious: #205CC0;\n$flattr: #F67C1A;\n$android: #A4C639;\n$tumblr: #34465d;\n$wikipedia: #333333;\n$stumbleupon: #eb4924;\n$foursquare: #f94877;\n$digg: #191919;\n$spotify: #81B71A;\n$reddit: #ff5700;\n$cc: #688527;\n$vk: #4c75a3;\n$rss: #EE802F;\n$podcast: #E4B21B;\n$dropbox: #007ee5;\n$github: #171515;\n$soundcloud: #ff3300;\n$wordpress: #21759b;\n$yelp: #af0606;\n$scribd: #666666;\n$cc-stripe: #008CDD;\n$drupal: #27537A;\n$slideshare: #0077b5;\n$get-pocket: #EE4056;\n$bitbucket: #0E4984;\n$stack-overflow: #EF8236;\n$hacker-news: #ff6600;\n$xing: #126567;\n$instagram: #e4405f;\n$quora: #b92b27;\n$openid: #E16309;\n$steam: #111111;\n$amazon: #E47911;\n$weibo: #df2029;\n$blogger: #f57d00;\n$whatsapp: #25D366;\n$wechat: #09b83e;\n$line: #00c300;\n$medium: #02b875;\n$vine: #00b489;\n$slack: #3aaf85;\n$snapchat: #FFFC00;\n","@mixin clearfix() {\n\t&::after {\n\t\tcontent: \"\";\n\t\tclear: both;\n\t\tdisplay: table;\n\t}\n}\n\n@mixin placeholder-color($placeholder-color) {\n\t::-webkit-input-placeholder {\n\t\tcolor: $placeholder-color\n\t}\n\n\t:-moz-placeholder {\n\t\tcolor: $placeholder-color\n\t}\n\n\t::-moz-placeholder {\n\t\tcolor: $placeholder-color\n\t}\n\n\t:-ms-input-placeholder {\n\t\tcolor: $placeholder-color\n\t}\n}\n\n\n\n// Gradient color\n@mixin gradient-color($value, $deg) {\n\t@if $value==a {\n\t\tbackground:linear-gradient($deg#{deg}, #f71595 0%, #ed560e 62%, #ff9600 100%);\n\t\tbackground-clip: text;\n\t\t-webkit-text-fill-color: transparent;\n\t}\n\n\t@else if $value==b {\n\t\tbackground:linear-gradient($deg#{deg}, rgb(251, 110, 57) 12%, rgb(252, 85, 93) 50%, rgb(253, 59, 128) 91%);\n\t\tbackground-clip: text;\n\t\t-webkit-text-fill-color: transparent;\n\t}\n\n\t@else if $value==c {\n\t\tbackground:linear-gradient($deg#{deg}, rgb(40, 172, 225) 12%, rgb(81, 204, 231) 50%, rgb(122, 235, 236) 91%);\n\t\tbackground-clip: text;\n\t\t-webkit-text-fill-color: transparent;\n\t}\n}\n\n\n\n// Gradient Background\n@mixin gradient-bg($value, $deg) {\n\t@if $value==a {\n\t\tbackground:linear-gradient($deg#{deg}, #ffffff 0%, transparent 95%);\n\t}\n\n\t@else if $value==b {\n\t\tbackground:linear-gradient($deg#{deg}, rgba(223, 32, 32, 1) 0%, rgba(0, 0, 0, 0.6) 36%, rgba(0, 0, 0, 0.3) 100%);\n\t}\n\n\t@else if $value==c {\n\t\tbackground:linear-gradient($deg#{deg}, rgb(40, 172, 225) 12%, rgb(81, 204, 231) 50%, rgb(122, 235, 236) 91%);\n\t}\n}","/**\n * Utilities\n */\n\n.pda-wrapper {\n  margin-top: 56px;\n  padding-left: 301px;\n  z-index: 3;\n}\n\n.pda-with-layout-body-wrapper {\n  padding: 20px;\n}\n\n.pda-float-left {\n  float: left;\n  font-family: artifakt;\n  font-weight: bold;\n}\n.pda-float-right {\n  padding-left: 15px;\n  float:right;\n}\n","/**\r\n * Button\r\n */\r\n.pda-dropdown-button {\r\n  padding: $sidenav-padding-left;\r\n  text-decoration: none;\r\n  font-size: $sidenav-font-size;\r\n  color: #ffffff;\r\n  display: block;\r\n  border: none;\r\n  transition: $transition;\r\n  width:100%;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  outline: none;\r\n  &.active {\r\n      background: rgba($color-sidenav-active, 0.2);\r\n      color: $color-sidenav-active;\r\n  }\r\n\r\n  &:hover {\r\n      color: $color-sidenav-active;\r\n  }\r\n}\r\n\r\n.pda-upload-button {\r\n\r\n  &.with-card {\r\n    padding-top: 10px;\r\n    font-family: artifakt;\r\n    left: 80.3%;\r\n    top: 10px;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n\r\n.pda-upload-button-large {\r\n  font-family: artifakt;\r\n  left: 66.6%;\r\n  top: 10px;\r\n}\r\n\r\n.pda-button {\r\n  background-color: #0696d7;\r\n  border-color: #0696d7;\r\n  border: none;\r\n  color: white;\r\n  line-height: 15px;\r\n  // padding: 15px 25px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  transition: all 0.2s ease-in-out;\r\n  height: 40px;\r\n  font-size: 1.2rem;\r\n\r\n  &.grow {\r\n    width: 100%;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: #006EAF;\r\n    border-color: #006EAF;\r\n  }\r\n\r\n}\r\n\r\n.pda-button-export {\r\n  background-color: #0696d7;\r\n  border-color: #0696d7;\r\n  border: none;\r\n  color: white;\r\n  line-height: 15px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  transition: all 0.2s ease-in-out;\r\n  height: 40px;\r\n\r\n  &:hover {\r\n    background-color: #006EAF;\r\n    border-color: #006EAF;\r\n  }\r\n}\r\n\r\n.pda-button-radio {\r\n  label {\r\n    padding-left: 10px;\r\n    color: #414141;\r\n    font-size: 0.9em;\r\n    font-family: artifakt;\r\n  }\r\n}\r\n\r\n.pda-offering-upload-button-medium, .pda-locale-upload-button-medium {\r\n  padding-top: 10px;\r\n}\r\n","/**\r\n * Header Styles\r\n */\r\n\r\n.pda-header {\r\n  position: fixed;\r\n  width: 100%;\r\n   top: 0;\r\n  z-index: 2;\r\n}\r\n","/**\n * Header Styles\n */\n\n.pda-sidenav {\n    position: fixed;\n    padding-top: 5px;\n    height: 100vh;\n    width: 300px;\n    background: lighten($color-sidenav, 5);\n    border-right: 1px solid $color-sidenav-border;\n    z-index: 1;\n\n    h4 {\n      font-family: sans-serif;\n      font-weight:550;\n      font-size: 23px;\n      padding-left: $padding-side-nav-left;\n      padding-top: $padding-side-nav-top;\n    }\n\n    &-dropdown {\n      padding-left: 20px;\n      line-height: 120%;\n      li {\n        display: inline-block;\n      }\n      &.hidden {\n        display:none;\n      }\n    }\n\n    &-inner {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: center;\n        overflow: hidden;\n        overflow-y: auto;\n    }\n\n    &-toggler {\n        position: absolute;\n        left: 100%;\n        top: 20px;\n        padding: 0;\n        height: $input-button-height;\n        width: 50px;\n        text-align: center;\n        font-size: 1.6rem;\n        background: lighten($color-bg-body, 5);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        display: none;\n\n        &:focus{\n            border-color: $color-border;\n        }\n    }\n\n    &-image {\n        padding: 20px 0;\n        display: block;\n        width: 100%;\n        text-align: center;\n        border-bottom: 1px solid $color-border;\n\n        a {\n            height: 200px;\n            width: 200px;\n            border-radius: 1000px;\n            border: 7px solid $color-border;\n            overflow: hidden;\n            display: inline-block;\n            vertical-align: middle;\n        }\n    }\n\n    &-menu {\n        width: 100%;\n        margin: 15px 0;\n\n        li {\n            list-style: none;\n            text-align:left;\n            display: block;\n\n            &:not(:last-child) {\n                margin-bottom: 1px;\n            }\n\n            a {\n                text-transform:capitalize;\n                text-decoration: none;\n                font-size: $sidenav-font-size;\n                letter-spacing: $sidenav-letter-spacing;\n                display: block;\n                padding: $sidenav-font-padding;\n                padding-left: $sidenav-padding-left;\n                color: $color-sidenav-inactive;\n                transition: $transition;\n                font-weight: $sidenav-font-weight;\n                position: relative;\n\n                &.active {\n                  background: rgba($color-sidenav-active, 0.2);\n                  color: $color-sidenav-active;\n                }\n\n                &:hover {\n                  color: $color-sidenav-active;\n                }\n            }\n        }\n    }\n\n    &-copyright {\n        display: block;\n        width: 100%;\n        text-align: center;\n        margin-bottom: 0;\n        font-size: 1rem;\n        padding: 15px 0;\n        border-top: 1px solid $color-border;\n\n        a{\n            color: $color-body;\n            transition: $transition;\n\n            &:hover{\n                color: $color-theme;\n            }\n        }\n    }\n\n    &.is-visible{\n        transform: translateX(0);\n    }\n}\n\n.pda-submodule {\n  color: black;\n  background-color: black;\n}\n\n.pda-section-disabled {\n  opacity: 0.3;\n  pointer-events:none;\n}\n",".pda-page-container {\n  padding-left: 10px;\n  height: 600px;\n}\n\n.pda-button-radio-container{\n  padding: 20px;\n}\n\n.pda-page-text-container {\n  position: relative;\n  padding-left: 10px;\n  padding-top: 2%;\n}\n\n.pda-page-wrapped-component-container {\n  position: relative;\n  padding-top: 20%;\n  padding-left: 50%;\n}\n\n.pda-page-title {\n  position: relative;\n  padding-top: 1%;\n}\n\n.pda-page-description {\n  position: relative;\n  padding-top: 5%;\n}\n\n.pda-home-card-1 {\n  float: left;\n  padding-left: 30px;\n}\n.pda-home-card-2 {\n  position: relative;\n  padding-left: 30px;\n  float: left;\n}\n\n.pda-home-info {\n  font-family: artifakt;\n  color:#4d4d4d;\n  font-weight: bold;\n  padding-top: 30px;\n  padding-left: 30px;\n  padding-bottom: 15px;\n\n  &-support {\n    font-family: artifakt;\n    color:#4d4d4d;\n    font-weight: bold;\n  }\n}\n",".pda-drag-drop-card {\n  background: white;\n  height: 250px;\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  min-width: 400px;\n  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.1);\n\n\n  &-body {\n    margin: 20px auto;\n    width: 90%;\n    padding: 3px;\n    align-items: center;\n    background: white;\n    border: 1px dashed #dcdcdc;\n    height: 11.5em;\n    display: inline-block;\n    border-radius: 6px;\n    outline: none;\n\n    h5, h6{\n      color: #312f2f;\n      font-family: artifakt;\n    }\n\n    h5 {\n      font-size: 1.2rem;\n      padding: 20px;\n    }\n\n    h6 {\n        font-size: 1rem;\n    }\n\n    &:hover {\n      cursor: pointer;\n      border: 1px dashed #7993b0;\n      background: rgba(128, 128, 128, 0.05);\n      box-shadow: 0 3px 6px 0 rgba(0,0,0,0.1);\n      transition: 0.3s;\n    }\n  }\n}\n\n.pda-drad-drop-card-input {\n  color: white;\n  border: 1px solid white;\n}\n\n.pda-upload-grid-wrapper {\n  padding-top: 50px;\n}\n\n.pda-offering-effective-date-upload-container {\n  p {\n    font-family: artifakt;\n    font-size: 0.9rem;\n    color: #4d4d4d;\n    padding-top: 10px;\n  }\n}\n\n.pda-offering-upload-container {}\n\n.pda-upload-progress-bar {\n  position: relative;\n  padding-top: 30px;\n}\n\n.pda-selection-container {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%)\n}\n","/*\r\n * Title\r\n */\r\n\r\n\r\n.mi-sectiontitle {\r\n  margin-bottom: 60px;\r\n  position: relative;\r\n  z-index: 1;\r\n\r\n  span {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 100%;\r\n    font-size: 6rem;\r\n    line-height: 1;\r\n    font-weight: 900;\r\n    color: rgba(25, 29, 43, 0.44);\r\n    display: inline-block;\r\n    text-transform: uppercase;\r\n    z-index: -1;\r\n    transform: translateY(-40%);\r\n    user-select: none;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  h2 {\r\n    font-weight: 700;\r\n    position: relative;\r\n    padding-bottom: 15px;\r\n    text-transform: uppercase;\r\n\r\n    &::before {\r\n      content: \"\";\r\n      position: absolute;\r\n      left: 0;\r\n      top: auto;\r\n      bottom: 0;\r\n      height: 5px;\r\n      width: 100px;\r\n      background: rgba($color-theme, 0.3);\r\n      border-radius: 100px;\r\n    }\r\n\r\n    &::after {\r\n      position: absolute;\r\n      left: 0;\r\n      top: auto;\r\n      bottom: 0;\r\n      height: 5px;\r\n      width: 35px;\r\n      background: $color-theme;\r\n      border-radius: 100px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-laptop} {\r\n    span {\r\n      font-size: 4.5rem;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-notebook} {\r\n    span {\r\n      font-size: 4.5rem;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-tablet} {\r\n    margin-bottom: 50px;\r\n\r\n    span {\r\n      font-size: 4.2rem;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-mobile-lg} {\r\n    margin-bottom: 40px;\r\n\r\n    span {\r\n      font-size: 3.8rem;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-mobile-sm} {\r\n    span {\r\n      font-size: 3.2rem;\r\n    }\r\n  }\r\n}\r\n\r\n.mi-smalltitle {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  h4 {\r\n    font-weight: 700;\r\n  }\r\n\r\n  &-icon {\r\n    vertical-align: middle;\r\n    margin-right: 10px;\r\n    font-size: 1.71rem;\r\n    line-height: 2.43rem;\r\n    color: $color-body;\r\n  }\r\n\r\n  @media #{$layout-mobile-lg}{\r\n    &-icon{\r\n      font-size: 1.51rem;\r\n      line-height: 2.13rem;\r\n    }\r\n  }\r\n}\r\n",".pda-modal {\n  width: 25rem;\n  max-width: 90%;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.26);\n  position: fixed;\n  left: 50%;\n  top: 30%;\n  transform: translate(-50%, -50%);\n\n  &-header {\n    height: 60px;\n    padding-left: 15px;\n    padding-top: 15px;\n    color: rgba(60, 60, 60, 0.9);\n    background-color: rgba(0, 0, 0, 0.05);\n    font-size: 23px;\n    font-weight: bold;\n    font-family: artifakt;\n    // border-bottom: 1px solid rgba(0, 0, 0, 0.25);\n  }\n\n  &-footer{\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    padding: 1rem;\n  }\n\n  &-body {\n    height: 150px;\n    padding-left: 5%;\n  }\n\n  &-actions {\n    display: flex;\n    justify-content: flex-end;\n    padding: 1rem;\n  }\n\n  &-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100%;\n    background: rgba(0,0,0,0.75);\n  }\n}\n\n.pda-login-error {\n  p {\n    color: #ec4a41;\n    font-size: 300;\n  }\n}\n\n.pda-summary-card {\n  transition: opacity 50000000ms ease-in;\n  border-radius: 5px;\n  width: 100%;\n\n  &.primary{\n    background-color: #C7E7F5;\n  }\n\n  &.secondary{\n    background-color: #FFCCCC;\n  }\n\n  &-icon {\n    padding: 10px;\n    float: left;\n  }\n\n  &-title {\n    padding: 13px;\n    p {\n      font-weight: bold;\n      font-family: artifakt;\n    }\n    &.primary{\n      color: #2786AF;\n    }\n\n    &.secondary{\n      color: #F37D7D;\n    }\n  }\n\n  &-body {\n    padding-left: 40px;\n    font-family: artifakt;\n    font-size: 0.85em;\n    padding-bottom: 25px;\n\n    &.primary{\n      color: #2786AF;\n    }\n\n    &.secondary{\n      color: #F37D7D;\n    }\n  }\n}\n\n.pda-backdrop {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  padding: 1rem;\n  background-color: rgba(0, 0, 0, 0.35);\n  z-index: 4;\n  opacity: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  animation: show .5s ease;\n}\n\n.pda-card {\n  &-header {\n    background-color: #ffffff;\n    padding: 10px;\n    padding-left: 20px;\n    color: #4d4d4d;\n    font-family: artifakt;\n    font-weight: bold;\n    font-size: 1rem;\n    border-radius: 5px;\n  }\n  &-body {\n    padding-left: 20px;\n    padding-bottom: 10px;\n    background-color: #ffffff;\n    color: #4d4d4d;\n    font-family: artifakt;\n    font-size: 0.85rem;\n    border-radius: 5px;\n  }\n  &-medium {\n    &-light {\n      box-shadow: 0 2px 6px 0 rgba(0,0,0,0.1);\n      transition: 0.3s;\n      background-color: white;\n      border-radius: 5px;\n      color: white;\n      font-family: artifakt;\n      width: 15rem;\n      &:hover {\n        // box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n      }\n    }\n\n  }\n\n  &-small {\n\n  }\n\n  &-large {\n\n  }\n}\n\n\n.pda-modal-content {\n  display: flex;\n  justify-content: space-between;\n  height: 152px;\n  text-align: center;\n}\n\n.pda-offering-date-picker-container {\n  padding-left: 20px;\n}\n\n.pda-offering-upload-container {\n  padding-top: 10px;\n  padding-left: 20px;\n}\n.pda-locale-upload-container {\n  padding-top: 10px;\n  float: inherit;\n}\n\n.pda-offerings-available-downloads {\n  padding-top: 20px;\n\n  &-export-button {\n    padding-left: 20px;\n    padding-top: 30px;\n  }\n\n  &-list {\n    padding-left: 40px;\n    ul {\n      li {\n        color: #4d4d4d;\n        font-family: artifakt;\n        font-size: 1.0rem;\n        a {\n          color: #006EAF;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n}\n\n\n.pda-offering-date-picker-input {\n  border-radius: 5px;\n  border-color: white;\n  background-color: white;\n}\n\n@media (min-width: 768px) {\n  .modal {\n    width: 50rem;\n    left: calc((100% - 50rem) / 2);\n  }\n}\n","/*\r\n * Home Styles\r\n */\r\n\r\n.mi-home{\r\n  &-area{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n\r\n  &-particle{\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: -1;\r\n  }\r\n\r\n  &-content{\r\n    text-align: center;\r\n    padding: 50px 80px;\r\n\r\n    h1{\r\n      font-weight: 700;\r\n    }\r\n\r\n    p{\r\n      margin-top: 15px;\r\n      font-size: 1.25rem;\r\n      line-height: 2rem;\r\n    }\r\n\r\n    .mi-socialicons{\r\n      margin-top: 20px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-laptop}{\r\n    &-content{\r\n      padding: 50px 0px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-notebook}{\r\n    &-content{\r\n      padding: 50px 0px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-tablet}{\r\n    &-content{\r\n      padding: 50px 0px;\r\n\r\n      p{\r\n        font-size: 1.15rem;\r\n        line-height: 1.75rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media #{$layout-mobile-lg}{\r\n    &-content{\r\n      padding: 50px 0px;\r\n\r\n      p{\r\n        font-size: 1.08rem;\r\n        line-height: 1.55rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media #{$layout-mobile-sm}{\r\n    &-content{\r\n      h1{\r\n        span{\r\n          display: block;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","/*\r\n * About Styles\r\n */\r\n\r\n.mi-about {\r\n  &-image {\r\n    position: relative;\r\n\r\n    &::before {\r\n      content: \"\";\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      height: 65%;\r\n      width: 15px;\r\n      background: rgba($color-theme, 0.6);\r\n    }\r\n\r\n    &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      left: auto;\r\n      right: 0;\r\n      top: auto;\r\n      bottom: 0;\r\n      height: 65%;\r\n      width: 15px;\r\n      background: rgba($color-theme, 0.6);\r\n    }\r\n\r\n    img {\r\n      width: 100%;\r\n    }\r\n\r\n    &-icon {\r\n      position: absolute;\r\n      left: 50%;\r\n      top: 50%;\r\n      height: 100px;\r\n      width: 100px;\r\n      margin-left: -50px;\r\n      margin-top: -50px;\r\n      color: #ffffff;\r\n      display: inline-block;\r\n      visibility: hidden;\r\n      opacity: 0;\r\n      transform: scale(0);\r\n      transition: all 0.4s ease-out 0s;\r\n      pointer-events: none;\r\n  \r\n      svg {\r\n        height: 100%;\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    &:hover &-icon{\r\n      visibility: visible;\r\n      opacity: 0.5;\r\n      transform: scale(1);\r\n    }\r\n  }\r\n\r\n  &-content {\r\n    h3 {\r\n      font-weight: 600;\r\n      margin-top: -8px;\r\n    }\r\n\r\n    ul {\r\n      li {\r\n        list-style: none;\r\n        display: flex;\r\n\r\n        &:not(:last-child) {\r\n          margin-bottom: 3px;\r\n        }\r\n\r\n        b {\r\n          min-width: 120px;\r\n          display: inline-block;\r\n          position: relative;\r\n          margin-right: 7px;\r\n\r\n          &:after {\r\n            content: \":\";\r\n            position: absolute;\r\n            top: 0;\r\n            left: auto;\r\n            right: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .mi-button{\r\n      margin-top: 15px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-tablet}{\r\n    &-content{\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-mobile-lg}{\r\n    &-image{\r\n      &-icon{\r\n        height: 70px;\r\n        width: 70px;\r\n        margin-left: -35px;\r\n        margin-top: -35px;\r\n      }\r\n    }\r\n    &-content{\r\n      margin-top: 30px;\r\n\r\n      ul{\r\n        li{\r\n          b{\r\n            min-width: 90px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","/**\r\n * Contact\r\n */\r\n\r\n.mi-contact {\r\n  &-info {\r\n    margin-top: -30px;\r\n  }\r\n\r\n  &-infoblock {\r\n    margin-top: 30px;\r\n    background: rgba(lighten($color-bg-body, 5), 1);\r\n    padding: 30px;\r\n    display: flex;\r\n\r\n    &-icon {\r\n      display: inline-block;\r\n      height: 70px;\r\n      width: 70px;\r\n      flex: 0 0 70px;\r\n      max-width: 70px;\r\n      border: 1px solid $color-border;\r\n      text-align: center;\r\n      line-height: 66px;\r\n      margin-right: 20px;\r\n\r\n      svg {\r\n        height: 30px;\r\n        width: 30px;\r\n      }\r\n    }\r\n\r\n    &-content {\r\n      h6 {\r\n        margin-top: -5px;\r\n      }\r\n\r\n      p {\r\n        margin-bottom: 0;\r\n\r\n        a {\r\n          color: $color-body;\r\n          transition: $transition;\r\n\r\n          &:hover {\r\n            color: $color-theme;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media #{$layout-tablet} {\r\n    &-info {\r\n      margin-top: 50px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-mobile-lg} {\r\n    &-info {\r\n      margin-top: 50px;\r\n    }\r\n  }\r\n\r\n  @media #{$layout-mobile-sm} {\r\n    &-infoblock {\r\n      padding: 20px;\r\n      flex-wrap: wrap;\r\n\r\n      &-icon {\r\n        height: 55px;\r\n        width: 55px;\r\n        flex: 0 0 55px;\r\n        max-width: 55px;\r\n        line-height: 51px;\r\n      }\r\n\r\n      &-content{\r\n        margin-top: 20px;\r\n        flex: 0 0 100%;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
